import axios from "axios";
import {getField, updateField} from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    helpsteps: [],
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {

  }
}
